import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SlotsPropertiesActions from "../../store/actions/Slots";

const instructions = [
  "Slot Compliance On driver level will be exempted",
  "Star Gigs if exist for the given slot capacity and driver, then it will be exempted",
  "We can revert the above exemptions by passing the exemptions flag as false",
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const DriverSlotsExemption = ({ getDriverSlotsExemptionUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="driverSlotsExemptionBtn"
      uploadUrl="/driver-shift/slot/bulk-driver-slots-exempted/ack"
      sampleURL="/sample/bulk_driver_slots_exemption.csv"
      id="driverSlotsExemptionModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Gigs exemption upload (Driver)"
      getUploadUrl={getDriverSlotsExemptionUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getDriverSlotsExemptionUrl: bindActionCreators(
      SlotsPropertiesActions.getDriverSlotsExemptionUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(DriverSlotsExemption);
